module.exports = __webpack_public_path__ + "img/lock-02.bb2502b6.svg";